import React, { useContext } from "react";
import tick from "../../resources/images/tick.svg";
import cross from "../../resources/images/close-red.svg";
import closeW from "../../resources/images/close-white.svg";
import useWindowSize from "../../lib/use-window-size";
import { LanguageContext } from "../../context/language-context";
import t from "../../resources/translations";
import { Handles, Rail, Slider, Tracks } from "react-compound-slider";

const MultiBlok = ({ opts, value, setValue, dict }) => {
  const l = useContext(LanguageContext).locale;
  return (
    <ul className="">
      {opts.map((o) => {
        const isSelected = value.has(o);
        return (
          <li
            key={o}
            className="mt-1 is-comm-flex px-3 cursor-pointer hover:bg-is-bg-prodotti rounded-small py-2"
            onClick={() => {
              if (isSelected) {
                value.delete(o);
                setValue(value);
              } else {
                value.add(o);
                setValue(value);
              }
            }}
          >
            <span
              className={`text-white capitalize ${
                isSelected ? "font-bold" : ""
              }`}
            >
              {dict ? dict[o][l] : o}
            </span>
            {isSelected ? (
              <img src={tick} alt="selected" />
            ) : (
              <img src={cross} alt="not selected" />
            )}
          </li>
        );
      })}
    </ul>
  );
};

const Handle = ({ handle: { id, value, percent }, getHandleProps }) => {
  return (
    <div
      style={{
        left: `${percent}%`,
      }}
      className="absolute z-20 text-center bg-is-blue text-is-blue rounded-full cursor-pointer border-none h-[18px] w-[18px] ml-[-9px] mt-7"
      {...getHandleProps(id)}
    >
      <div className="-mt-8 w-20 -ml-8 text-center">{value}</div>
    </div>
  );
};

const Track = ({ source, target, getTrackProps }) => {
  return (
    <div
      style={{
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      className="absolute h-2 rounded-full mt-8 bg-is-blue z-10 cursor-pointer"
      {
        ...getTrackProps() /* this will set up events if you want it to be clickeable (optional) */
      }
    />
  );
};

const RangeBlok = ({ opts, value, setValue }) => {
  const [min, max] = opts;
  const [value1, value2] = value;
  return (
    <div className="p-3">
      <Slider
        domain={[min, max]}
        mode={2}
        values={[value1, value2]}
        step={1.0}
        className="relative text-is-blue h-9"
        onChange={([v1, v2]) => {
          setValue([v1, v2]);
        }}
      >
        <Rail>
          {({ getRailProps }) => (
            <div
              className="bg-is-range-slider w-full absolute h-2 rounded-full mt-8 cursor-pointer"
              {...getRailProps()}
            />
          )}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks right={false} left={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
      <div className="is-comm-flex text-white mt-6 -mx-2">
        <p>{opts[0]}</p>
        <p>{opts[1]}</p>
      </div>
    </div>
  );
};

const opt2comp = {
  range: RangeBlok,
  multi: MultiBlok,
};

const FilterBlok = ({
  filters,
  setFilters,
  options,
  filtriMobileOpen,
  setFiltriMobileOpen,
  setPagination,
  hideSubcats = false,
}) => {
  const l = useContext(LanguageContext).locale;
  const { isMobile } = useWindowSize();
  return (
    <div
      className="md:w-1/4 md:flex-shrink-0 top-0 absolute md:static rounded-r-is md:rounded-is bg-is-dark-gray shadow-is md:block transition-all p-4 z-40 md:mb-6"
      style={
        isMobile
          ? {
              width: "calc(100vw - 40px)",
              left: filtriMobileOpen ? "-0.875rem" : "calc(-100% - 40px)",
            }
          : {}
      }
    >
      <div className="flex items-center">
        <h2 className="is-h3b text-is-blue">{t.filtri[l]}</h2>
        <div className="h-px bg-white ml-2 mr-10 flex-grow mt-2" />
        <img
          src={closeW}
          alt={t.chiudiFiltri[l]}
          className="md:hidden mr-2 cursor-pointer"
          aria-label="button"
          role="button"
          onClick={() => {
            setFiltriMobileOpen(false);
          }}
        />
      </div>
      <div className="py-2">
        {Object.entries(options)
          .filter(hideSubcats ? ([name]) => name !== "categoria" : (p) => true)
          .map(([name, opt]) => {
            const Component = opt2comp[opt.type];
            return (
              <div key={name} className="mt-6">
                <h3 className="is-h4 text-is-blue">{t[name][l]}</h3>
                <Component
                  opts={opt.values}
                  dict={opt.dict}
                  value={filters[name].value}
                  setValue={(newValue) => {
                    setFilters((currentFilters) => ({
                      ...currentFilters,
                      [name]: {
                        type: opt.type,
                        value: newValue,
                      },
                    }));
                    setPagination(0);
                  }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default FilterBlok;
